import {getAvailableTariffs, goToStep, setImmediatePurchaseProps} from "../slices/OrderSlice";
import {EntityPaymentTypes} from "../constants/payment";
import {FlowType} from "../constants/flowType";
import urlApi from "../../../actions/urlApi";
import {bookFlowSteps} from "../payment/Flows";
import { CurrencyType } from "@brg/api";

export const CopyBook = async (book: any, bookCards: any, bookCard: any, price: number, isCopying: any, params: {dispatch: any, t: any, i18n: any, toasts: any, modal: any }) => {

    const {
        dispatch,
        t,
        toasts,
        modal
    } = params
    const productEntityType = EntityPaymentTypes.book

    if(isCopying?.current) {
        return
    }
    isCopying.current = true

    // TODO доделать метод копированя
    const copiedCardId: any = await urlApi().addBookCard(bookCard?.bookData?.bookId, bookCard?.bookData?.cardIds, bookCard?.bookData?.chapterIds)
    if(!copiedCardId) {
        toasts.error(`${t('card_constructor.messages.copycard_error')}. ${t('try_again')}. `);
        isCopying.current = false
        return
    }

    const goToSuccess = () => {
        modal.hide()
        modal.show("bookPaymentSuccess", {
            products: [book],
            isCopy: true,
            containerStyles: {
                background: 'rgba(231,231,231, 0.90)',
                backdropFilter: 'none'
            },
            onCustomClose: () => {
                window.location.reload()
            }
        })
    }

    dispatch(setImmediatePurchaseProps({
        productId: copiedCardId,
        paymentEntityType: EntityPaymentTypes.book,
        flowType: FlowType.COPY_BOOK,
        currencyType: CurrencyType.RealMoney,
        preventGetCurrencies: true,
        bookId: book?.projectId || book?.bookId,
        price: price || 0,
        productInfo: {
            name: book?.title || "",
            preview: book?.titleImages,
            price: price || 0,
            type: EntityPaymentTypes.book,
            cardInfo: bookCards
        },
    }))
    if (isCopying) {
        isCopying.current = false
    }
    goToStep && dispatch(goToStep(bookFlowSteps['default']))
    dispatch(getAvailableTariffs({entityType: productEntityType, bookCardId: bookCard?.cardId}))
    modal.show("paymentManager", {
        flowType: FlowType.COPY_BOOK,
        onPaymentSuccess: goToSuccess,
        onPaymentFail: () => {
            modal.show('paymentUnavailable')
            // goToStep && dispatch(goToStep(bookFlowSteps['errorPayment']))
        },
        close: () => {
            goToStep && dispatch(goToStep(bookFlowSteps['default']));
        }
    })
}import {getAvailableTariffs, goToStep, setImmediatePurchaseProps} from "../slices/OrderSlice";
import {EntityPaymentTypes} from "../constants/payment";
import {FlowType} from "../constants/flowType";
import urlApi from "../../../actions/urlApi";
import {bookFlowSteps} from "../payment/Flows";
import { CurrencyType } from "@brg/api";

export const CopyBook = async (book: any, bookCards: any, bookCard: any, price: number, isCopying: any, params: {dispatch: any, t: any, i18n: any, toasts: any, modal: any }) => {

    const {
        dispatch,
        t,
        toasts,
        modal
    } = params
    const productEntityType = EntityPaymentTypes.book

    if(isCopying?.current) {
        return
    }
    isCopying.current = true

    // TODO доделать метод копированя
    const copiedCardId: any = await urlApi().addBookCard(bookCard?.bookData?.bookId, bookCard?.bookData?.cardIds, bookCard?.bookData?.chapterIds)
    if(!copiedCardId) {
        toasts.error(`${t('card_constructor.messages.copycard_error')}. ${t('try_again')}. `);
        isCopying.current = false
        return
    }

    const goToSuccess = () => {
        modal.hide()
        modal.show("bookPaymentSuccess", {
            products: [book],
            isCopy: true,
            containerStyles: {
                background: 'rgba(231,231,231, 0.90)',
                backdropFilter: 'none'
            },
            onCustomClose: () => {
                window.location.reload()
            }
        })
    }

    dispatch(setImmediatePurchaseProps({
        productId: copiedCardId,
        paymentEntityType: EntityPaymentTypes.book,
        flowType: FlowType.COPY_BOOK,
        currencyType: CurrencyType.RealMoney,
        preventGetCurrencies: true,
        bookId: book?.projectId || book?.bookId,
        price: price || 0,
        productInfo: {
            name: book?.title || "",
            preview: book?.titleImages,
            price: price || 0,
            type: EntityPaymentTypes.book,
            cardInfo: bookCards
        },
    }))
    if (isCopying) {
        isCopying.current = false
    }
    goToStep && dispatch(goToStep(bookFlowSteps['default']))
    dispatch(getAvailableTariffs({entityType: productEntityType, bookCardId: bookCard?.cardId}))
    modal.show("paymentManager", {
        flowType: FlowType.COPY_BOOK,
        onPaymentSuccess: goToSuccess,
        onPaymentFail: () => {
            modal.show('paymentUnavailable')
            // goToStep && dispatch(goToStep(bookFlowSteps['errorPayment']))
        },
        close: () => {
            goToStep && dispatch(goToStep(bookFlowSteps['default']));
        }
    })
}